module.exports = __webpack_public_path__ + "img/jet-brains.8974425d.png";